<script setup>
</script>

<template>
  <div class="serverError">
    <div class="serverError__icon">
      <v-icon
        icon="fa-database"
        class="serverError__icon-database"
      />
      <div class="serverError__icon-xmark">
        <!-- <v-icon icon="fa-xmark" /> -->
      </div>
    </div>
    <div class="serverError__body">
      <h2 class="serverError__title">
        ページが見つかりません
      </h2>
      <p class="serverError__message">
        指定されたページ(URL)が見つかりません。
      </p>

      <router-link
        :to="{ name: 'AshibetuTop'}"
        replace
        class="networkError__button c-button c-button--border c-button--medium"
      >
        ホームへ
      </router-link>
    </div>
  </div>
</template>

<style scoped lang="scss">
.serverError{
  &__icon{
    height: 200px;
    width: 200px;
    position: relative;
    background: var(--frameColor);
    border-radius: 100%;
    margin: 0 auto 30px;
    box-shadow: 0 0 1px rgb(0 0 0 / 50%), 0 0 3px rgb(0 0 0 / 20%);
  }

  &__icon-database{
    height: 100px;
    width: 100px;
    display: block;
    margin: auto;
    position: absolute;
    inset: 0;
  }

  &__title{
    color: #dd2121;
    margin: 20px;
    text-align: center;
    font-size: 1.6rem;
  }

  &__button{
    margin-top: 30px;
  }
}
</style>
